/**
 * 路由切换时，权限验证模块
 *
 * @author vince
 */
import router from '@/router'
import store from '@/store'
import storage from 'store'
import Vue from 'vue'
import {getCredentials, storeCredentials, refreshCredentials, removeTempCredentials} from '@/utils/request'
import {getWechatJSSign} from '@/api/system'
import {wechatAuth} from '@/api/user'
import {isMobileOrTablet} from '@/utils/device'

// 页面切换时，顶部类似youtube的加载条
// import NProgress from 'nprogress'
// import 'nprogress/nprogress.css'
// NProgress.configure({ showSpinner: false })

// 在小程序内打开非本站点的页面时，用新的webview打开
router.open = (href, newTab, isReplace) => {
  function hrefDirect(href, newTab, isReplace) {
    let link = href
    if (href.indexOf('http') != 0 && href.indexOf('/') != 0) {
      link = window.location.protocol + '//' + href
    }
    console.log('hrefDirect', href, link, newTab, isReplace)
    if (newTab) {
      window.open(link, '_blank')
    } else if (isReplace) {
      window.location.replace(link)
    } else {
      window.location.href = link
    }
  }
  console.log('routerOpen', store.getters.is_miniprogram, href, newTab, isReplace, location.origin)
  
  if (store.getters.is_miniprogram) {
    if (href.indexOf(location.origin) == 0 ||
        href.indexOf('/') == 0) {
      hrefDirect(href, newTab, isReplace)
    } else {
      let path = `/pages/webview/index?url=${encodeURIComponent(href)}`
      console.log('href跳转小程序新webview', path)
      Vue.prototype.$mpNavigateTo({
        url: path,
        fail: (res) => {
          hrefDirect(href, newTab, isReplace)
        }
      })  
    }
  } else {
    hrefDirect(href, newTab, isReplace)
  }
}

// 进入网站时的第一个路由
let landingRouter = null

// 切换页面加载样式
router.beforeEach((to, from, next) => {
  // console.log('router',router, router.push, router.open)
  if (!from.name) {
    landingRouter = to
    if (to) {
      let env = to.query.env
      if (env &&
          (env == 'AACloud' ||
          env == 'AAAttachment' ||
          env == 'AAParent')) {
        store.dispatch('setIsMiniprogram', true)
        if (env == 'AAAttachment') {
          store.dispatch('setMpAppId', process.env.AAAttachment_MP_APP_ID)
        } else if (env == 'AAParent') {
          store.dispatch('setMpAppId', process.env.AAParent_MP_APP_ID)
        } else if (env == 'AACloud') {
          store.dispatch('setMpAppId', process.env.AACloud_MP_APP_ID)
        }
        console.log('setIsMiniprogram', true, env)
      }
      let version = to.query.v
      if (version) {
        store.dispatch('setMiniprogramVersion', version)
        console.log('setMiniprogramVersion', version)
      }
    }
  }
  // 判断是不是简单的hash改变
  let isSame = true
  if ((!to || !from) || to.name != from.name) {
    isSame = false
  } else {
    function dictEqual(toParams, fromParams) {
      if (!toParams && !fromParams) {
        return true
      }
      if ((!toParams && fromParams) || (toParams && !fromParams)) {
        return false
      }
      if (Object.keys(toParams).length != Object.keys(fromParams).length) {
        return false
      }
      let isEqual = true
      for (const toKey in toParams) {
        if (Object.hasOwnProperty.call(toParams, toKey)) {
          const toValue = toParams[toKey];
          if (!Object.hasOwnProperty.call(fromParams, toKey) || fromParams[toKey] != toValue) {
            isEqual = false
          }
        }
      }
      return isEqual
    }
    if (!dictEqual(to.params, from.params) || !dictEqual(to.query, from.query)) {
      isSame = false
    }
  }
  console.log('路由准备跳转：', from, to)
  console.log('跳转是否相同：', isSame)
  if (isSame) {
    return false
  }
  
  /**
   * 记录页面跳转来源
   */
  to.meta.from = from.name && from
  // 传递source
  if (from.name != 'create_class_success' &&
      from.name != 'create_class_success_new' && 
      from.query.source) {
    if (!to.query.source || from.query.source != to.query.source) {
      to.query.source = from.query.source
    }
  }
  /**
   * 如果是登录跳转页面
   * 则进行登录授权验证
   */
  if (to.name == 'wechat_auth') {
    store.dispatch('startLoading')
    wechatAuthRequest(to)
    return false
  }


  const credential = getCredentials()
  // 如果用户未授权
  // 则去登录授权获得token
  if(!to.meta.no_auth && !credential) {
    beforeGoNext(from, to)

    const refer = location.href
    if (store.getters.is_wechat || store.getters.is_miniprogram) {
      store.dispatch('goWechatAuth', {refer})

    } else {
      router.replace({
        name: 'pc_login',
        query: {refer: refer}
      })
    }

    return false
  }

  // 判断是否使用新版发布页
  if (to.name == 'create_notification' || to.name == 'create_homework') {
    if (storage.get('new-publish-version') && !to.query.t) {
      let query = to.query
      query.t = new Date().getTime()
      router.push({
        name: to.name,
        params: to.params,
        query: query
      })
      return false
    }
  }
  // 检查是否要打开带插屏广告的webview
  const adPageKV = Vue.$adManager.pageKV
  const adPageNames = Object.keys(adPageKV)
  console.log('adPageNames', adPageNames, to)
  if (store.getters.is_miniprogram && from.name && to.name && adPageNames.indexOf(to.name) >= 0 && from.meta.from != to) {
    // let data = adPageKV[to.name]
    // let toRoute = {
    //   name: to.name,
    //   params: to.params,
    //   query: to.query
    // }
    // toRoute.query.backMP = 1
    // let fullPath = router.resolve(toRoute).href
    // let url = location.origin + fullPath
    // data.url = encodeURIComponent(url)
    
    // 返回后不需要刷新页面
    // let fromRoute = {
    //   name: from.name,
    //   params: from.params,
    //   query: from.query
    // }
    // fromRoute.query.t = new Date().getTime()
    // let fromFullPath = router.resolve(fromRoute).href
    // let fromUrl = location.origin + fromFullPath
    // data.rediCB = encodeURIComponent(fromUrl)
    
    let data = { ...to.params, ...to.query }
    data.from = 'webview'
    let queryStr = ''
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        const value = data[key];
        if (queryStr) {
          queryStr = queryStr + '&'
        }
        queryStr = queryStr + key + '=' + value
      }
    }
    let path = `/pages/${to.name}/index?${queryStr}`
    console.log('跳转小程序新webview', path)
    Vue.prototype.$mpNavigateTo({
      url: path
    })

    return false
  }
  /**
   * 数据初始化
   */
  if (!store.state.app.initialized && 
      to.name != 'server_exception' &&
      to.name != 'server_pause') {
    beforeGoNext(from, to)
    // console.log('loadInitialData000',from, to)
    store.dispatch('loadInitialData')
    .then((data) => {
      // 用户未登录
      if (!data.user) {
        // 访问页面无需登录，则直接通过
        if (to.meta.no_auth) {
          // console.log('loadInitialData111',data)
          next()
        
        // 访问页面需要登录
        // 则刷新token后访问
        } else {
          console.log('refreshCredentials-NoUser', data.user, JSON.stringify(data))
          removeTempCredentials()
          refreshCredentials(credential.refresh_token, credential.openid)
          .then((token) => {
            // console.log('loadInitialData333',token)
            store.dispatch('reload')
          }).catch((e) => {
            // console.log('loadInitialData444', e)

            const refer = location.href
            if (store.getters.is_wechat || store.getters.is_miniprogram) {
              store.dispatch('goWechatAuth', {refer})
            } else {
              router.replace({
                name: 'pc_login',
                query: {refer: refer}
              })
            }
          })
        }

      } else {
        // console.log('loadInitialData555', data)
        // 当前用户权限检测
        if (checkPermission(from, to)) {
          // console.log('loadInitialData666', data)
          next()
        }
      }
    }).catch((e) => {
      // console.log('loadInitialData777', e)
      
    })

  // 数据已经初始化
  } else {
    // console.log('loadInitialData888', to)
    if (checkPermission(from, to)) {
      // console.log('loadInitialData999', to)
      beforeGoNext(from, to)
      next()
    }
  }
})

router.afterEach((to,from) => {
  const path = to.fullPath
  const title = to.meta.title
  const name = to.name
  Vue.$eventAnalyse.page(title, path, name)
  // 生产环境发送百度统计
  if (process.env.NODE_ENV == 'production' || location.host == 'class.funp.in') {
    // let should_analyse = true
    // 不统计单纯的post详情页的访问
    // if (to.name.indexOf('_detail') > 0) {
    //   if (Object.keys(to.query) == 0) {
    //     should_analyse = false
    //   } else if (Object.keys(to.query) == 1 && to.query.from) {
    //     should_analyse = false
    //   }
    // }
    // if (should_analyse) {
      Vue.$eventAnalyse.bd_page(to.name, to.params, to.query)
    // }
  }

  // 如果是在微信浏览器中
  // 获取网页微信分享认证签名
  // 方便后面微信分享和其他sdk功能使用
  Vue.prototype.$sharePageInfo = null
  if (store.getters.is_wechat) {
    signWechat(to)
  }
})


/**
 * 是否有查看某个页面的权限
 */
const checkPermission = (from, to) => {
  if (to.meta.is_admin) {
    let isAdmin = store.getters.has_teacher_role || store.getters.committee_roles.length > 0
    if (isAdmin) {
      // 判断是否是这个班级的管理员
      const class_id = to.params.class_id
      if (class_id) {
        let has_match = false
        store.getters.teacher_roles.forEach((classRole) => {
          if (classRole.class.id == class_id) {
            has_match = true
          }
          // console.log('teacher_role', has_match, class_id, classRole.class.id)
        })
        store.getters.committee_roles.forEach((classRole) => {
          if (classRole.class.id == class_id) {
            has_match = true
          }
          // console.log('committee_role', has_match, class_id, classRole.class.id)
        })
        if (!has_match) {
          isAdmin = false
        }
      }
    }
    // 跳转到权限页面
    if (!isAdmin) {
      // 无身份用户：则跳转到新官网
      if (store.getters.class_roles.length == 0 ) {
        let redirect = null
        if (!isMobileOrTablet()) {
          let source = ''
          if (to.query.source) {
            source = to.query.source
          } else if (from.query.source) {
            source = from.query.source
          } else if (from && from.name) {
            source = `8-wqx-${from.name}`
          } else {
            source = '8-wuquanx-wushenfen'
          }
          let query = {}
          if (source) {
            query.source = source
          }

          redirect = router.resolve({name: 'create_publish_scores', query: query})
        } else {
          let source = ''
          if (to.query.source) {
            source = to.query.source
          } else if (to.query.from && to.query.from.charAt(0) == '7') {
            if (store.state.user.source && (store.state.user.source == '7-official-qrcode')) {
              source = to.query.from
            } else {
              source = store.state.user.source || to.query.from
            }
          } else if (store.state.user.source) {
            source = store.state.user.source
          }
          let query = {}
          if (source) {
            query.source = source
          }
          redirect = router.resolve({name: 'new_home', query: query})
        }
        location.href = redirect.href
      } else {
        // 家长：无权限页面
        let source = ''
        if (to.query.source) {
          source = to.query.source
        } else if (to.query.from && to.query.from.charAt(0) == '7') {
          if (store.state.user.source && (store.state.user.source == '7-official-qrcode')) {
            source = to.query.from
          } else {
            source = store.state.user.source || to.query.from
          }
        } else if (store.state.user.source) {
          source = store.state.user.source
        } else {
          source = '2-wuquanxian'
        }
        let query = {}
        if (source) {
          query.source = source
        }
        router.push({name: 'admin_permission_denied', query: query})
      }
      return false
    }
  // } else if (!to.meta.no_auth) {
    // 如果是要授权的页面，判断用户是否有这个班级或者孩子的身份
    
  }
  return true
}

/**
 * 确定进入下一路由前的准备工作
 * 如：标题设置，加载动画等
 *
 * @author vince
 */
const beforeGoNext = (from, to) => {
  /**
    * 标题设置
    */
  if (to.meta.title) {
    document.title = to.meta.title
  }

  /**
   * 非站内跳转页面
   * 即第一次加载
   */
  if (!from.name) {
    store.dispatch('initialLoading')

  } else {
    /**
     * 页面加载
     */
    store.dispatch('startLoading')
  }

  // 给出停止加载方法，
  // 方便对应路由组件停止加载动画
  to.meta.stopLoading = () => {
    store.dispatch('stopLoading')
  }
  // 开始加载
  to.meta.startLoading = () => {
    store.dispatch('startLoading')
  }
}

/**
 * 微信sdk使用签名
 * 签名后，页面内才能使用this.$wechat.调用微信sdk功能
 *
 * @author vince
 */
const signWechat = (route) => {
  let url = location.href

  if (navigator.userAgent.indexOf('Android') >= 0) {
    url = location.origin + route.fullPath.replace(route.hash, '').replace(':', '%3A')
  }

  if (navigator.userAgent.indexOf('iPhone') >= 0) {
    url = location.origin + landingRouter.fullPath.replace(route.hash, '').replace(':', '%3A')
  }
  // console.log('准备签名:',url,location.href)
  getWechatJSSign(url)
  .then((res) => {
    res.data.jsApiList = [
      'checkJsApi',
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'onMenuShareWeibo',
      'onMenuShareQZone',
      'hideMenuItems',
      'showMenuItems',
      'hideAllNonBaseMenuItem',
      'showAllNonBaseMenuItem',
      'translateVoice',
      'startRecord',
      'stopRecord',
      'onVoiceRecordEnd',
      'playVoice',
      'onVoicePlayEnd',
      'pauseVoice',
      'stopVoice',
      'uploadVoice',
      'downloadVoice',
      'chooseImage',
      'previewImage',
      'uploadImage',
      'downloadImage',
      'getNetworkType',
      'openLocation',
      'getLocation',
      'hideOptionMenu',
      'showOptionMenu',
      'closeWindow',
      'scanQRCode',
      'chooseWXPay',
      'openProductSpecificView',
      'addCard',
      'chooseCard',
      'openCard',
      'getLocalImgData',
    ]
    res.data.openTagList = ['wx-open-launch-weapp']
    if (process.env.NODE_ENV == 'test') {
      // res.data.debug = true
    }
    console.log('wechat.config', res.data)
    Vue.wechat.config(res.data)
    Vue.wechat.ready((res) => {
      console.log('微信签名:','wx sign ready', res)
    })
    Vue.wechat.error((res) => {
      console.log('微信签名错误:', res, url, location.href)
    })
  })
}

/**
 * 微信code认证授权请求处理
 */
const wechatAuthRequest = (route) => {
  const wechatCode = route.query.code
  const wechatState = route.query.state

  // 授权成功后跳转的页面
  let refer = route.query.refer

  if (!wechatCode) {
    router.push({name: 'notfound'})
    return false
  }

  // 通过code, state注册/授权用户
  // 获得登录token
  wechatAuth(wechatCode, wechatState)
  .then((res) => {
    // 请求成功，跳转回原来的页面
    if (res.code == 1) {
      const token = res.data.user.token
      const refresh_token = res.data.user.refresh_token
      const openid = res.data.user.openid

      storeCredentials(token, refresh_token, openid)

      // 跳转回原有网页
      location.replace(refer)

    // 授权请求失败
    } else {
      Vue.$vux.toast.text(`授权失败，请稍后再试: ${res.message}`)
    }

  }).catch((e) => {
    console.log(e)
    Vue.$vux.toast.text(`授权失败，请稍后再试: ${e.message}`)
  })
}




// WEBPACK FOOTER //
// ./src/permission.js